import { render, staticRenderFns } from "./CustomPropertValueAppreciationRatesTable.vue?vue&type=template&id=4c44259f&scoped=true&"
import script from "./CustomPropertValueAppreciationRatesTable.vue?vue&type=script&lang=js&"
export * from "./CustomPropertValueAppreciationRatesTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomPropertValueAppreciationRatesTable.vue?vue&type=style&index=0&id=4c44259f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c44259f",
  null
  
)

export default component.exports